<template>
  <div
    class="promotion_item"
    :class="promotion.is_ended ? 'completed' : ''"
  >
    <nuxt-link :to="getPromotionUrl" class="pi_image_wrap">
      <div class="pi_image">
        <nuxt-img
          :src="$options.filters.mediaUrl(promotion, 'avatar', 'path')"
          :alt="$imgMeta('alt', promotion.title)"
          :title="$imgMeta('title', promotion.title)"
          width="380"
          height="275"
          format="webp"
          background="transparent"
          layout="responsive"
          fit="cover"
          loading="lazy"
        />
      </div>
      <div class="pi_sticker" v-text="$i18n.t('catalog.promotion_item')" />
      <div v-if="promotion.is_ended" class="completed_sticker" v-text="$i18n.t('catalog.promotion_completed')" />
    </nuxt-link>
    <div class="pi_descr">
      <div class="date_wrap">
        <i class="calendar_icon" />
        {{ $t('catalog.promotion_from') }} {{ promotion.started_at }} {{ $t('catalog.promotion_to') }} {{ promotion.ended_at }}
      </div>
      <nuxt-link :to="getPromotionUrl" class="promo_title">
        {{ promotion.title }}
      </nuxt-link>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    promotion: {
      type: Object,
      default: null
    }
  },
  computed: {
    getPromotionUrl () {
      return this.localePath({ name: 'promotions-slug', params: { slug: this.promotion.slug } }) + '/'
    }
  }
}
</script>
